import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem, ConfirmationService } from 'primeng/api';
import { ArtTypeService } from 'src/app/Services/art-type.service';  // Make sure to import the correct service
import { ArtistsService } from 'src/app/Services/artists.service';
import { AuthConfig, AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { SetupItems } from 'src/app/models/setupItems';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-art-type',
    templateUrl: './art-type.component.html',
    styleUrls: ['./art-type.component.css'],
    providers: [ArtTypeService, ArtistsService],
    standalone: false
})
export class ArtTypeComponent {
  isEditMode: boolean = false;
  public CloudinaryImageService: SetupItems[] = [];
  public isAuthenticated: boolean = false;
  public formData: SetupItems = {} as SetupItems;
  public loading = true;
  public visible: boolean = false;
  public authConfig: AuthConfig = {};
  public artTypes: SetupItems[] = [];

  constructor(
    private confirmationService: ConfirmationService,
    private router: Router,
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private artTypeService: ArtTypeService,
    private authService: AuthService,
    private transloco: TranslocoService,
  ) { }

  public ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    this.getArtTypes();
  }

  private getArtTypes() {
    this.loading = true;
    this.artTypeService.fetch().subscribe(
      (artTypes: SetupItems[]) => {
        this.artTypes = artTypes;
        this.loading = false;
      }, (error) => { console.error('Error fetching art types:', error); this.loading = false; });
  }

  public showDialog() {
    this.visible = true;
    this.isEditMode = false;
  }

  public closeDialog() {
    this.visible = false;
    this.formData = {} as SetupItems;
  }

  public saveArtType(addNew: boolean) {
    this.ngxSpinnerService.show();
    if (this.isEditMode) {
      this.artTypeService.save(this.formData).subscribe(
        (response) => {
          this.handleSaveResponse(response, addNew);
        },
        (error) => {
          console.error(error);
          this.ngxSpinnerService.hide();
        }
      );
    } else {
      const newArtType: SetupItems = {
        Name: this.formData.Name,
        Description: this.formData.Description,
        // Other properties as needed
      };

      this.artTypeService.save(newArtType).subscribe(
        (response) => {
          this.handleSaveResponse(response, addNew);
        },
        (error) => {
          console.error(error);
          this.ngxSpinnerService.hide();
        }
      );
    }
  }

  private handleSaveResponse(response: ResponseObject, addNew: boolean) {
    this.ngxSpinnerService.hide();
    if (response.Success) {
      this.getArtTypes();
      this.notificationsService.showNotification(this.transloco.translate('artType.success'), this.transloco.translate('artType.dataSavedSuccessfully'), NotificationTypes.Success);
      if (addNew) {
        this.formData = {} as SetupItems;
      } else {
        this.visible = false;
      }
    } else {
      this.notificationsService.showNotification(this.transloco.translate('artType.error'), response.ResponseMessage, NotificationTypes.Error);
    }
  }

  public editArtType(id: string) {
    const currentArtType = this.artTypes.find((artType) => artType.Id === id);

    if (currentArtType) {
      this.formData.Id = currentArtType.Id;
      this.formData.Name = currentArtType.Name;
      this.formData.Description = currentArtType.Description;

      this.visible = true;
      this.isEditMode = true;
    }
  }

  public deleteArtType(id: string) {
    this.confirmationService.confirm({
      accept: () => {
        this.ngxSpinnerService.show();
        this.artTypeService.delete(id).subscribe(
          (response) => {
            this.ngxSpinnerService.hide();
            if (response.Success) {
              const index = this.artTypes.findIndex((artType) => artType.Id === id);

              if (index !== -1) {
                this.artTypes.splice(index, 1);
              }

              this.notificationsService.showNotification(this.transloco.translate('artType.success'), this.transloco.translate('artType.artTypeDeletedSuccessfully'), NotificationTypes.Success);
            } else {
              this.notificationsService.showNotification(this.transloco.translate('artType.error'), response.ResponseMessage, NotificationTypes.Error);
            }
          },
          (error) => {
            console.error(error);
            this.ngxSpinnerService.hide();
          }
        );
      },
    });
  }
}
